import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import navbarimage from "assets/img/layout/Navbar.png";
import { BsArrowBarUp } from "react-icons/bs";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import { FiLogOut } from "react-icons/fi";
import { MdLanguage } from "react-icons/md";
import avatar from "assets/img/avatars/avatar.jpeg";
import avatar1 from "assets/img/avatars/avatar1.jpeg";
import { useAuth } from "../../context/AuthContext";
import Breadcrumbs from "components/breadcrumbs";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const navigate = useNavigate();
  const { user, logout, currentLang, changeLanguage } = useAuth();

  return (
    <nav className="sticky top-2 md:top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <Breadcrumbs />
        <h1 className="shrink hidden md:block text-[33px] capitalize text-navy-700 dark:text-white">
            {brandText}
        </h1>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-lg md:rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[230px] md:flex-grow-0 md:gap-1 xl:w-[230px] xl:gap-2">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Уведомления
                </p>
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  Прочитать все
                </p>
              </div>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    Уведомление
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                   Здесь еще пусто...
                  </p>
                </div>
              </button>

            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />
        {/* start Horizon PRO */}
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              LIUKIT SEO CRM<br/>
              Версия 1.1.23 Beta 2
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        
        {/* Language Switcher */}
        <Dropdown
          button={
            <div className="flex items-center cursor-pointer">
              <MdLanguage className="h-4 w-4 text-gray-600 dark:text-white" />
              <span className="ml-1 text-xs font-medium text-gray-600 dark:text-white">
                {currentLang.toUpperCase()}
              </span>
            </div>
          }
          children={
            <div className="flex w-32 flex-col gap-1 rounded-[20px] bg-white p-3 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <button
                onClick={() => changeLanguage('ru')}
                className={`flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  currentLang === 'ru'
                    ? 'bg-brand-500 text-white'
                    : 'text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/10'
                }`}
              >
                Русский
              </button>
              <button
                onClick={() => changeLanguage('en')}
                className={`flex items-center rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                  currentLang === 'en'
                    ? 'bg-brand-500 text-white'
                    : 'text-gray-700 hover:bg-gray-100 dark:text-white dark:hover:bg-white/10'
                }`}
              >
                English
              </button>
            </div>
          }
          classNames={"py-2 top-6 -left-[100px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={user?.id && user?.id == 3 ? avatar1 : avatar}
              alt=""
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Привет, {user?.name || user?.email || 'Пользователь'}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <Link to="/auth/user"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white mb-3 flex items-center space-x-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  <span>Настройки профиля</span>
                </Link>
                <Link to="/auth/login-logs"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white flex items-center space-x-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <span>Журнал авторизаций</span>
                </Link> 
                <button
                  onClick={() => {
                    logout();
                    navigate('/auth/sign-in');
                  }}
                  className="mt-3 flex items-center text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in"
                >
                  <FiLogOut className="mr-2 h-4 w-4" />
                  Выйти
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
